// import React, { useState, useMemo, useEffect } from "react";
// import { Product } from "../../../types/types";
// import ListView from "../../../components/common/ListView";
// import { T } from "../../../context/LanguageContext";
// import { IconPencil, IconTrash, IconGlobe } from "@tabler/icons-react";

// interface ProductDetailViewProps {
//   product: Product;
//   promos?: any[];
//   gifts?: any[];
//   onEditProduct?: (product: Product) => void;
//   onEditPromo?: (promo: any) => void;
//   onEditGift?: (gift: any) => void;
//   onTogglePromoStatus?: (id: string, currentStatus: string) => void;
//   onToggleGiftStatus?: (id: string, currentStatus: string) => void;
//   onClose?: () => void;
// }

// export const ProductDetailView: React.FC<ProductDetailViewProps> = ({
//   product,
//   promos = [],
//   gifts = [],
//   onEditProduct,
//   onEditPromo,
//   onEditGift,
//   onTogglePromoStatus,
//   onToggleGiftStatus,
//   onClose,
// }) => {
//   const [activeTab, setActiveTab] = useState("Variants");

//   const productSkus = useMemo(() => {
//     return [
//       product.sku,
//       product.id,
//       ...(product.variants?.map((v: any) => v.sku) || []),
//       ...(product.variants?.map((v: any) => v.id) || []),
//     ].filter(Boolean);
//   }, [product]);

//   const matchedPromos = useMemo(() => {
//     if (!promos || !Array.isArray(promos)) return [];
//     return promos.filter((p: any) =>
//       p.products?.some((item: any) => {
//         const itemSku = (item.productSku || item.sku || item.productId || "").toString();
//         return productSkus.some(
//           (s) => s.toString().toLowerCase() === itemSku.toLowerCase()
//         );
//       })
//     );
//   }, [promos, productSkus]);

//   const matchedGifts = useMemo(() => {
//     if (!gifts || !Array.isArray(gifts)) return [];
//     return gifts.filter((g: any) =>
//       productSkus.some(
//         (s) =>
//           s.toString().toLowerCase() === (g.mainProductSku || "").toString().toLowerCase() ||
//           s.toString().toLowerCase() === (g.giftProductSku || "").toString().toLowerCase()
//       )
//     );
//   }, [gifts, productSkus]);

//   const customsFields = useMemo(() => {
//     if (!product.compliance) return { hasHsCode: false, hasOrigin: false, hasDestination: false, hasRoute: false, hasDuty: false, hasVat: false, hasLicense: false, hasDocuments: false, hasAny: false };
//     const c = product.compliance;
//     const hasHsCode = Boolean(c.hsCode && String(c.hsCode).trim() !== "" && String(c.hsCode) !== "—");
//     const hasOrigin = Boolean(c.origin && String(c.origin).trim() !== "" && String(c.origin) !== "—");
//     const hasDestination = Boolean(c.destination && String(c.destination).trim() !== "" && String(c.destination) !== "—");
//     const hasRoute = hasOrigin || hasDestination;
//     const hasDuty = Boolean(
//       c.duty !== undefined &&
//       c.duty !== null &&
//       String(c.duty).trim() !== "" &&
//       String(c.duty) !== "0" &&
//       String(c.duty) !== "0.00" &&
//       String(c.duty) !== "—"
//     );
//     const hasVat = Boolean(
//       c.vat !== undefined &&
//       c.vat !== null &&
//       String(c.vat).trim() !== "" &&
//       String(c.vat) !== "0" &&
//       String(c.vat) !== "0.00" &&
//       String(c.vat) !== "15" &&
//       String(c.vat) !== "15.00" &&
//       String(c.vat) !== "—"
//     );
//     const hasLicense = Boolean(
//       c.license &&
//       String(c.license).trim() !== "" &&
//       String(c.license) !== "Not Required" &&
//       String(c.license) !== "—"
//     );
//     const hasDocuments = Boolean(
//       c.documents &&
//       String(c.documents).trim() !== "" &&
//       String(c.documents) !== "—"
//     );
//     const hasAny = hasHsCode || hasRoute || hasDuty || hasVat || hasLicense || hasDocuments;
//     return { hasHsCode, hasOrigin, hasDestination, hasRoute, hasDuty, hasVat, hasLicense, hasDocuments, hasAny };
//   }, [product.compliance]);

//   const hasDimensions = useMemo(() => {
//     if (!product.dimensions) return false;
//     const d = product.dimensions;
//     return Boolean(
//       (d.weight && String(d.weight).trim() !== "" && d.weight !== "—") ||
//       (d.length && String(d.length).trim() !== "" && d.length !== "—") ||
//       (d.width && String(d.width).trim() !== "" && d.width !== "—") ||
//       (d.height && String(d.height).trim() !== "" && d.height !== "—")
//     );
//   }, [product.dimensions]);

//   const hasStorage = useMemo(() => {
//     if (!product.storage) return false;
//     if (Array.isArray(product.storage)) {
//       return product.storage.some(
//         (s: any) => s && (s?.type || s?.storageType) && (s?.capacity || s?.trigger || s?.minimumQuantity)
//       );
//     }
//     return Boolean(
//       (product.storage.type || (product.storage as any)?.storageType) &&
//       (product.storage.capacity || (product.storage as any)?.trigger || (product.storage as any)?.minimumQuantity)
//     );
//   }, [product.storage]);

//   const availableTabs = useMemo(() => {
//     const list: Array<{ label: string; count: number }> = [];
//     if (product.variants && product.variants.length > 0) {
//       list.push({ label: "Variants", count: product.variants.length });
//     }
//     if (matchedPromos && matchedPromos.length > 0) {
//       list.push({ label: "Promo", count: matchedPromos.length });
//     }
//     if (matchedGifts && matchedGifts.length > 0) {
//       list.push({ label: "Gift", count: matchedGifts.length });
//     }
//     return list;
//   }, [product.variants, matchedPromos, matchedGifts]);

//   useEffect(() => {
//     if (availableTabs.length > 0 && !availableTabs.some((t) => t.label === activeTab)) {
//       setActiveTab(availableTabs[0].label);
//     }
//   }, [availableTabs, activeTab]);

//   const getFormattedImgUrl = (url?: string) => {
//     if (!url) return "";
//     if (
//       url.startsWith("http://") ||
//       url.startsWith("https://") ||
//       url.startsWith("blob:") ||
//       url.startsWith("data:")
//     ) {
//       return url;
//     }
//     const baseUrl = process.env.REACT_APP_BASE_URL || "";
//     const cleanPath = url.startsWith("/") ? url : `/${url}`;
//     return `${baseUrl}${cleanPath}`;
//   };

//   const imgUrl = getFormattedImgUrl(product.image);

//   return (
//     <div className="space-y-4 text-[#212121]">
//       {/* Product Summary Header Card */}
//       <div className="bg-gradient-to-b from-[#FFFDF5] to-[#FFF7D6] rounded-2xl border border-slate-200 p-4 space-y-3 shadow-xs">
//         <div className="flex justify-between items-start gap-4">
//           <div className="flex gap-4 items-start">
//             {imgUrl ? (
//               <img
//                 src={imgUrl}
//                 alt={product.name}
//                 onError={(e) => {
//                   (e.target as HTMLElement).style.display = "none";
//                 }}
//                 className="w-20 h-20 rounded-xl object-cover bg-white border border-[#D2D2D2] shrink-0 shadow-xs"
//               />
//             ) : (
//               <div className="w-20 h-20 rounded-xl bg-slate-100 border border-[#D2D2D2] shrink-0 flex items-center justify-center text-slate-400">
//                 <IconGlobe size={28} />
//               </div>
//             )}
//             <div className="space-y-1">
//               <div className="flex flex-wrap gap-1.5 mb-1">
//                 {product.features?.hasVariants && (
//                   <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-yellow-100 text-yellow-700 border border-yellow-200/50">
//                     Variants
//                   </span>
//                 )}
//                 {product.features?.hasExpiry && (
//                   <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-700 border border-amber-200/50">
//                     Expiry
//                   </span>
//                 )}
//                 {product.features?.isDangerousGoods && (
//                   <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-rose-100 text-rose-700 border border-rose-200/50">
//                     Dangerous
//                   </span>
//                 )}
//                 {customsFields.hasAny && (
//                   <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-emerald-100 text-emerald-700 border border-emerald-200/50">
//                     Customs
//                   </span>
//                 )}
//                 {(matchedPromos.length > 0 || (product.features as any)?.hasPromo) && (
//                   <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-purple-100 text-purple-700 border border-purple-200/50">
//                     Promo
//                   </span>
//                 )}
//                 {(matchedGifts.length > 0 || (product.features as any)?.hasGift) && (
//                   <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-blue-100 text-blue-700 border border-blue-200/50">
//                     Gift
//                   </span>
//                 )}
//               </div>
//               <h2 className="text-base text-[#212121] font-bold">
//                 SKU: {product.sku}
//               </h2>
//               <h3 className="text-sm font-semibold text-[#212121]">
//                 {product.name}
//               </h3>
//               {product.category && (
//                 <p className="text-xs font-medium bg-white/80 text-[#212121]/70 px-2.5 py-0.5 rounded border border-slate-200 inline-block">
//                   {product.category}
//                 </p>
//               )}
//             </div>
//           </div>

//           <div className="text-right shrink-0 space-y-1">
//             <span className="text-base font-bold text-[#212121] block">
//               SAR {product.price}
//             </span>
//             {product.discount > 0 && (
//               <span className="text-xs font-medium text-red-600 bg-red-50 px-2 py-0.5 rounded border border-red-100 inline-block">
//                 (-SAR {product.discount})
//               </span>
//             )}
//             <div className="pt-1">
//               <span
//                 className={`px-2.5 py-0.5 rounded border text-[10px] font-semibold capitalize inline-block ${
//                   (product.status || "ACTIVE").toUpperCase() === "ACTIVE"
//                     ? "bg-emerald-50 text-emerald-700 border-emerald-200"
//                     : "bg-rose-50 text-rose-700 border-rose-200"
//                 }`}
//               >
//                 {product.status || "ACTIVE"}
//               </span>
//             </div>
//           </div>
//         </div>

//         {(product.shortDesc || product.longDesc) && (
//           <div className="border-t border-dashed border-slate-200 pt-2 space-y-1 text-xs text-[#212121]/80">
//             {product.shortDesc && (
//               <p>
//                 <b>Short Description:</b> {product.shortDesc}
//               </p>
//             )}
//             {product.longDesc && (
//               <p>
//                 <b>Long Description:</b> {product.longDesc}
//               </p>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Specifications Details View */}
//       <div className="space-y-3">
//         {/* Storage Profile & Dimensions Profile */}
//         {(hasStorage || hasDimensions) && (
//           <div className="border border-dashed border-[#D2D2D2] rounded-xl overflow-hidden bg-white w-full">
//             <div className={`grid ${hasStorage && hasDimensions ? "grid-cols-2 divide-x divide-dashed divide-[#D2D2D2]" : "grid-cols-1"} w-full items-stretch`}>
//               {/* Storage */}
//               {hasStorage && (
//                 <div className="w-full flex flex-col h-full">
//                   <div className="bg-gray-50 px-3 py-1.5 border-b border-dashed border-[#D2D2D2] w-full">
//                     <span className="text-xs font-semibold text-[#212121] block">
//                       Storage
//                     </span>
//                   </div>
//                   {Array.isArray(product.storage) ? (
//                     product.storage.map((s: any, idx: number) => (
//                       <div
//                         key={idx}
//                         className="grid grid-cols-3 text-center divide-x divide-dashed divide-[#D2D2D2] border-b border-dashed border-[#D2D2D2] last:border-0 w-full flex-1 items-stretch"
//                       >
//                         <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
//                           <p className="text-[10px] font-medium text-[#212121]/70">Type:</p>
//                           <p className="text-[10px] font-medium text-[#212121]">
//                             {s?.type || s?.storageType || "BINS"}
//                           </p>
//                         </div>
//                         <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
//                           <p className="text-[10px] font-medium text-[#212121]/70">Cap:</p>
//                           <p className="text-[10px] font-medium text-[#212121]">
//                             {s?.capacity ?? "—"}
//                           </p>
//                         </div>
//                         <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
//                           <p className="text-[10px] text-rose-500">Tri:</p>
//                           <p className="text-[10px] font-medium text-rose-600">
//                             {s?.trigger ?? s?.minimumQuantity ?? "—"}
//                           </p>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="grid grid-cols-3 text-center divide-x divide-dashed divide-[#D2D2D2] border-b border-dashed border-[#D2D2D2] last:border-0 w-full flex-1 items-stretch">
//                       <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
//                         <p className="text-[10px] font-medium text-[#212121]/70">Type:</p>
//                         <p className="text-[10px] font-medium text-[#212121]">
//                           {product.storage?.type || (product.storage as any)?.storageType || "BINS"}
//                         </p>
//                       </div>
//                       <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
//                         <p className="text-[10px] font-medium text-[#212121]/70">Cap:</p>
//                         <p className="text-[10px] font-medium text-[#212121]">
//                           {product.storage?.capacity ?? "—"}
//                         </p>
//                       </div>
//                       <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
//                         <p className="text-[10px] text-rose-500">Tri:</p>
//                         <p className="text-[10px] font-medium text-rose-600">
//                           {product.storage?.trigger ?? (product.storage as any)?.minimumQuantity ?? "—"}
//                         </p>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* Dimensions */}
//               {hasDimensions && (
//                 <div className="w-full flex flex-col h-full">
//                   <div className="bg-gray-50 px-3 py-1.5 border-b border-dashed border-[#D2D2D2] w-full">
//                     <span className="text-xs font-semibold text-[#212121] block">
//                       Dimensions
//                     </span>
//                   </div>
//                   <div className="grid grid-cols-4 text-center divide-x divide-dashed divide-[#D2D2D2] w-full flex-1 items-stretch">
//                     <div className="flex flex-col items-center justify-center py-2.5 px-1 h-full">
//                       <p className="text-[10px] font-medium text-[#212121]/70 whitespace-nowrap">Weight:</p>
//                       <p className="text-[10px] font-medium text-[#212121] mt-0.5 whitespace-nowrap">
//                         {product.dimensions?.weight && product.dimensions.weight !== "—"
//                           ? `${product.dimensions.weight} g`
//                           : "—"}
//                       </p>
//                     </div>
//                     <div className="flex flex-col items-center justify-center py-2.5 px-1 h-full">
//                       <p className="text-[10px] font-medium text-[#212121]/70 whitespace-nowrap">Length:</p>
//                       <p className="text-[10px] font-medium text-[#212121] mt-0.5 whitespace-nowrap">
//                         {product.dimensions?.length && product.dimensions.length !== "—"
//                           ? `${product.dimensions.length} cm`
//                           : "—"}
//                       </p>
//                     </div>
//                     <div className="flex flex-col items-center justify-center py-2.5 px-1 h-full">
//                       <p className="text-[10px] font-medium text-[#212121]/70 whitespace-nowrap">Width:</p>
//                       <p className="text-[10px] font-medium text-[#212121] mt-0.5 whitespace-nowrap">
//                         {product.dimensions?.width && product.dimensions.width !== "—"
//                           ? `${product.dimensions.width} cm`
//                           : "—"}
//                       </p>
//                     </div>
//                     <div className="flex flex-col items-center justify-center py-2.5 px-1 h-full">
//                       <p className="text-[10px] font-medium text-[#212121]/70 whitespace-nowrap">Height:</p>
//                       <p className="text-[10px] font-medium text-[#212121] mt-0.5 whitespace-nowrap">
//                         {product.dimensions?.height && product.dimensions.height !== "—"
//                           ? `${product.dimensions.height} cm`
//                           : "—"}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {/* Customs Details */}
//         {customsFields.hasAny && product.compliance && (
//           <div className="border border-dashed border-[#D2D2D2] rounded-xl overflow-hidden bg-white space-y-1.5">
//             <div className="bg-gray-50 px-3 py-1.5 border-b border-dashed border-[#D2D2D2] flex justify-between items-center">
//               <span className="text-xs font-semibold text-[#212121] block">
//                 Customs Details
//               </span>
//               {customsFields.hasHsCode && (
//                 <span className="text-[10px] text-indigo-600 font-bold tracking-wider">
//                   HS CODE {product.compliance.hsCode}
//                 </span>
//               )}
//             </div>
//             {(customsFields.hasRoute || customsFields.hasDuty || customsFields.hasVat || customsFields.hasLicense) && (
//               <div className="flex flex-wrap gap-x-4 gap-y-1 text-[#212121]/70 px-3 py-1">
//                 {customsFields.hasRoute && (
//                   <p className="text-[10px]">
//                     Route:{" "}
//                     <strong className="text-[#212121]">
//                       {product.compliance.origin || "—"} → {product.compliance.destination || "—"}
//                     </strong>
//                   </p>
//                 )}
//                 {customsFields.hasDuty && (
//                   <p className="text-[10px]">
//                     Tariffs:{" "}
//                     <strong className="text-emerald-600">
//                       {product.compliance.duty}% Duty
//                     </strong>
//                   </p>
//                 )}
//                 {customsFields.hasVat && (
//                   <p className="text-[10px]">
//                     VAT:{" "}
//                     <strong className="text-indigo-600">
//                       {product.compliance.vat}% Tax
//                     </strong>
//                   </p>
//                 )}
//                 {customsFields.hasLicense && (
//                   <p className="text-[10px]">
//                     Licence:{" "}
//                     <strong className="text-[#212121]">
//                       {product.compliance.license}
//                     </strong>
//                   </p>
//                 )}
//               </div>
//             )}
//             {customsFields.hasDocuments && (
//               <div className="text-[10px] text-[#212121]/60 pt-1 border-t border-[#D2D2D2] px-3 py-1.5">
//                 <strong>Mandatory Documentation:</strong> {product.compliance.documents}
//               </div>
//             )}
//           </div>
//         )}

//         {/* Dynamic Tabs: Variants / Promo / Gift */}
//         {availableTabs.length > 0 && (
//           <div className="border border-dashed border-[#D2D2D2] rounded-xl overflow-hidden bg-white">
//             <div className="bg-gray-50 px-3 py-1.5 border-b border-dashed border-[#D2D2D2] flex justify-between items-center">
//               {activeTab === "Variants" && (
//                 <p className="text-xs font-semibold text-[#212121] block">
//                   Variants Details ({product.variants?.length || 0})
//                 </p>
//               )}
//               {activeTab === "Promo" && (
//                 <p className="text-xs font-semibold text-[#212121] block">
//                   Promo ({matchedPromos.length})
//                 </p>
//               )}
//               {activeTab === "Gift" && (
//                 <p className="text-xs font-semibold text-[#212121] block">
//                   Gift ({matchedGifts.length})
//                 </p>
//               )}
//               <div className="flex items-center gap-2">
//                 {availableTabs.map((tab) => (
//                   <button
//                     key={tab.label}
//                     onClick={() => setActiveTab(tab.label)}
//                     className={`py-1 px-2.5 text-[10px] font-semibold rounded transition-all flex items-center justify-center border shrink-0 ${
//                       activeTab === tab.label
//                         ? "bg-[#FBD037]/20 text-[#000000] shadow-xs border-[#FBD037]"
//                         : "bg-slate-100 text-slate-600 border-slate-200"
//                     }`}
//                   >
//                     <span>
//                       <T>{tab.label}</T>
//                     </span>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <div className="grid grid-cols-1 gap-1 max-h-48 overflow-y-auto p-2">
//               {activeTab === "Variants" && product.variants && product.variants.length > 0 && (
//                 <ListView
//                   tdClassName="rounded-r-none rounded-l-none text-left bg-transparent py-1 text-[11px]"
//                   mainDivClassName="bg-transparent"
//                   trClassName="hover:bg-[#FBD037]/20"
//                   mailDivClassName="p-0 bg-transparent"
//                   thClassName="border-t text-left sticky top-0 z-20 text-[11px]"
//                   data={product.variants}
//                   columns={[
//                     {
//                       label: "#",
//                       render: (_: any, i: number) => <div>{i + 1}</div>,
//                     },
//                     {
//                       label: "SKU",
//                       render: (c: any) => <div>{c.sku || "—"}</div>,
//                     },
//                     {
//                       label: "Name",
//                       render: (c: any) => <div>{c.name || "Variant"}</div>,
//                     },
//                     {
//                       label: "Option Value",
//                       render: (c: any) => <div>{c.value || "—"}</div>,
//                     },
//                     {
//                       label: "Price (SAR)",
//                       render: (c: any) => (
//                         <div className="flex items-center gap-1 font-semibold">
//                           <img src="/img/riyal-icon.svg" className="w-2.5 h-2.5" alt="" />
//                           {c.price}
//                         </div>
//                       ),
//                     },
//                   ]}
//                 />
//               )}

//               {activeTab === "Promo" && (
//                 <ListView
//                   tdClassName="rounded-r-none rounded-l-none text-left bg-transparent py-1 text-[11px]"
//                   mainDivClassName="bg-transparent"
//                   trClassName="hover:bg-[#FBD037]/20"
//                   mailDivClassName="p-0 bg-transparent"
//                   thClassName="border-t text-left sticky top-0 z-20 text-[11px]"
//                   data={matchedPromos}
//                   onRowClick={(item: any) => onEditPromo?.(item)}
//                   columns={[
//                     {
//                       label: "#",
//                       render: (_: any, i: number) => <div>{i + 1}</div>,
//                     },
//                     {
//                       label: "Promo Code",
//                       render: (c: any) => (
//                         <div className="font-semibold text-[#212121]">
//                           {c.sku || c.promoCode || c.code || "PROMO-001"}
//                         </div>
//                       ),
//                     },
//                     {
//                       label: "Product SKU",
//                       render: (c: any) => {
//                         const match = c.products?.find((item: any) => {
//                           const itemSku = (item.productSku || item.sku || item.productId || "").toString();
//                           return productSkus.some(
//                             (s) => s.toString().toLowerCase() === itemSku.toLowerCase()
//                           );
//                         });
//                         const displaySku =
//                           (match?.productSku && match.productSku !== match.productId)
//                             ? match.productSku
//                             : product.sku;
//                         return (
//                           <div className="font-medium text-[#212121]">
//                             {displaySku}
//                           </div>
//                         );
//                       },
//                     },
//                     {
//                       label: "QTY",
//                       render: (c: any) => {
//                         const match = c.products?.find((item: any) => {
//                           const itemSku = (item.productSku || item.sku || item.productId || "").toString();
//                           return productSkus.some(
//                             (s) => s.toString().toLowerCase() === itemSku.toLowerCase()
//                           );
//                         });
//                         const qtyVal = match?.qty ?? match?.quantity ?? 1;
//                         return (
//                           <div className="font-semibold text-slate-700">
//                             {qtyVal}
//                           </div>
//                         );
//                       },
//                     },
//                     {
//                       label: "Date",
//                       render: (c: any) => (
//                         <div>
//                           {c.startDate && c.endDate
//                             ? `${c.startDate} - ${c.endDate}`
//                             : c.startDate || c.endDate || "—"}
//                         </div>
//                       ),
//                     },
//                     {
//                       label: "Status",
//                       render: (c: any) => {
//                         const isActive = (c.status || "ACTIVE").toString().toLowerCase() === "active";
//                         return (
//                           <button
//                             type="button"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               onTogglePromoStatus?.(c.id, c.status);
//                             }}
//                             className={`w-9 h-5 flex items-center rounded-full p-0.5 transition-colors duration-200 cursor-pointer ${
//                               isActive ? "bg-emerald-500" : "bg-slate-300"
//                             }`}
//                           >
//                             <div
//                               className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-200 ${
//                                 isActive ? "translate-x-4" : "translate-x-0"
//                               }`}
//                             />
//                           </button>
//                         );
//                       },
//                     },
//                   ]}
//                 />
//               )}

//               {activeTab === "Gift" && (
//                 <ListView
//                   tdClassName="rounded-r-none rounded-l-none text-left bg-transparent py-1 text-[11px]"
//                   mainDivClassName="bg-transparent"
//                   trClassName="hover:bg-[#FBD037]/20"
//                   mailDivClassName="p-0 bg-transparent"
//                   thClassName="border-t text-left sticky top-0 z-20 text-[11px]"
//                   data={matchedGifts}
//                   onRowClick={(item: any) => onEditGift?.(item)}
//                   columns={[
//                     {
//                       label: "#",
//                       render: (_: any, i: number) => <div>{i + 1}</div>,
//                     },
//                     {
//                       label: "Item / SKU",
//                       render: (g: any) => (
//                         <div className="space-y-1">
//                           <div className="flex items-center gap-1.5">
//                             <span className="font-bold text-[#212121]">{g.mainProductSku}</span>
//                             <span className="px-1.5 py-0.2 bg-amber-100 text-amber-800 text-[9px] font-bold rounded">
//                               MAIN
//                             </span>
//                           </div>
//                           {g.giftItems && g.giftItems.length > 0 ? (
//                             g.giftItems.map((gi: any, idx: number) => (
//                               <div key={idx} className="flex items-center gap-1.5 pl-3 text-slate-600 text-[10px]">
//                                 <span>↳ {gi.sku || gi.giftSku || gi.giftProductSku || g.giftProductSku}</span>
//                                 <span className="px-1.5 py-0.2 bg-emerald-100 text-emerald-800 text-[9px] font-bold rounded">
//                                   GIFT
//                                 </span>
//                               </div>
//                             ))
//                           ) : (
//                             <div className="flex items-center gap-1.5 pl-3 text-slate-600 text-[10px]">
//                               <span>↳ {g.giftProductSku || g.giftSku}</span>
//                               <span className="px-1.5 py-0.2 bg-emerald-100 text-emerald-800 text-[9px] font-bold rounded">
//                                 GIFT
//                               </span>
//                             </div>
//                           )}
//                         </div>
//                       ),
//                     },
//                     {
//                       label: "QTY",
//                       render: (g: any) => (
//                         <div className="space-y-1">
//                           <div>
//                             <span className="px-1.5 py-0.5 bg-amber-50 text-amber-900 font-bold rounded">
//                               {g.mainQty ?? g.triggerQty ?? 1}
//                             </span>
//                           </div>
//                           {g.giftItems && g.giftItems.length > 0 ? (
//                             g.giftItems.map((gi: any, idx: number) => (
//                               <div key={idx} className="pl-3">
//                                 <span className="px-1.5 py-0.2 bg-emerald-50 text-emerald-900 font-bold rounded">
//                                   +{gi.qty ?? gi.giftQty ?? g.giftQty ?? 1}
//                                 </span>
//                               </div>
//                             ))
//                           ) : (
//                             <div className="pl-3">
//                               <span className="px-1.5 py-0.2 bg-emerald-50 text-emerald-900 font-bold rounded">
//                                 +{g.giftQty ?? 1}
//                               </span>
//                             </div>
//                           )}
//                         </div>
//                       ),
//                     },
//                     {
//                       label: "Date",
//                       render: (g: any) => <div>{g.startDate ? `${g.startDate} - ${g.endDate}` : "—"}</div>,
//                     },
//                     {
//                       label: "Status",
//                       render: (g: any) => (
//                         <button
//                           type="button"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             onToggleGiftStatus?.(g.id, g.status);
//                           }}
//                           className={`w-9 h-5 flex items-center rounded-full p-0.5 transition-colors duration-200 cursor-pointer ${
//                             g.status === "active" ? "bg-emerald-500" : "bg-slate-300"
//                           }`}
//                         >
//                           <div
//                             className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-200 ${
//                               g.status === "active" ? "translate-x-4" : "translate-x-0"
//                             }`}
//                           />
//                         </button>
//                       ),
//                     },
//                   ]}
//                 />
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };



import React, { useState, useMemo, useEffect } from "react";
import { Product } from "../../../types/types";
import ListView from "../../../components/common/ListView";
import { T } from "../../../context/LanguageContext";
import { IconGlobe } from "@tabler/icons-react";

interface ProductDetailViewProps {
  product: Product;
  promos?: any[];
  gifts?: any[];
  onEditProduct?: (product: Product) => void;
  onEditPromo?: (promo: any) => void;
  onEditGift?: (gift: any) => void;
  onTogglePromoStatus?: (id: string, currentStatus: string) => void;
  onToggleGiftStatus?: (id: string, currentStatus: string) => void;
  onClose?: () => void;
}

export const ProductDetailView: React.FC<ProductDetailViewProps> = ({
  product,
  promos = [],
  gifts = [],
  onEditProduct,
  onEditPromo,
  onEditGift,
  onTogglePromoStatus,
  onToggleGiftStatus,
  onClose,
}) => {
  const [activeTab, setActiveTab] = useState("Variants");

  const productSkus = useMemo(() => {
    return [
      product.sku,
      product.id,
      ...(product.variants?.map((v: any) => v.sku) || []),
      ...(product.variants?.map((v: any) => v.id) || []),
    ].filter(Boolean);
  }, [product]);

  const matchedPromos = useMemo(() => {
    if (!promos || !Array.isArray(promos)) return [];
    return promos.filter((p: any) =>
      p.products?.some((item: any) => {
        const itemSku = (
          item.productSku ||
          item.sku ||
          item.productId ||
          ""
        ).toString();
        return productSkus.some(
          (s) => s.toString().toLowerCase() === itemSku.toLowerCase(),
        );
      }),
    );
  }, [promos, productSkus]);

  const matchedGifts = useMemo(() => {
    if (!gifts || !Array.isArray(gifts)) return [];
    return gifts.filter((g: any) =>
      productSkus.some(
        (s) =>
          s.toString().toLowerCase() ===
            (g.mainProductSku || "").toString().toLowerCase() ||
          s.toString().toLowerCase() ===
            (g.giftProductSku || "").toString().toLowerCase(),
      ),
    );
  }, [gifts, productSkus]);

  const customsFields = useMemo(() => {
    if (!product.compliance)
      return {
        hasHsCode: false,
        hasOrigin: false,
        hasDestination: false,
        hasRoute: false,
        hasDuty: false,
        hasVat: false,
        hasLicense: false,
        hasDocuments: false,
        hasAny: false,
      };
    const c = product.compliance;
    const hasHsCode = Boolean(
      c.hsCode && String(c.hsCode).trim() !== "" && String(c.hsCode) !== "—",
    );
    const hasOrigin = Boolean(
      c.origin && String(c.origin).trim() !== "" && String(c.origin) !== "—",
    );
    const hasDestination = Boolean(
      c.destination &&
      String(c.destination).trim() !== "" &&
      String(c.destination) !== "—",
    );
    const hasRoute = hasOrigin || hasDestination;
    const hasDuty = Boolean(
      c.duty !== undefined &&
      c.duty !== null &&
      String(c.duty).trim() !== "" &&
      String(c.duty) !== "0" &&
      String(c.duty) !== "0.00" &&
      String(c.duty) !== "—",
    );
    const hasVat = Boolean(
      c.vat !== undefined &&
      c.vat !== null &&
      String(c.vat).trim() !== "" &&
      String(c.vat) !== "0" &&
      String(c.vat) !== "0.00" &&
      String(c.vat) !== "15" &&
      String(c.vat) !== "15.00" &&
      String(c.vat) !== "—",
    );
    const hasLicense = Boolean(
      c.license &&
      String(c.license).trim() !== "" &&
      String(c.license) !== "Not Required" &&
      String(c.license) !== "—",
    );
    const hasDocuments = Boolean(
      c.documents &&
      String(c.documents).trim() !== "" &&
      String(c.documents) !== "—",
    );
    const hasAny =
      hasHsCode || hasRoute || hasDuty || hasVat || hasLicense || hasDocuments;
    return {
      hasHsCode,
      hasOrigin,
      hasDestination,
      hasRoute,
      hasDuty,
      hasVat,
      hasLicense,
      hasDocuments,
      hasAny,
    };
  }, [product.compliance]);

  const hasDimensions = useMemo(() => {
    if (!product.dimensions) return false;
    const d = product.dimensions;
    return Boolean(
      (d.weight && String(d.weight).trim() !== "" && d.weight !== "—") ||
      (d.length && String(d.length).trim() !== "" && d.length !== "—") ||
      (d.width && String(d.width).trim() !== "" && d.width !== "—") ||
      (d.height && String(d.height).trim() !== "" && d.height !== "—"),
    );
  }, [product.dimensions]);

  const hasStorage = useMemo(() => {
    if (!product.storage) return false;
    if (Array.isArray(product.storage)) {
      return product.storage.some(
        (s: any) =>
          s &&
          (s?.type || s?.storageType) &&
          (s?.capacity || s?.trigger || s?.minimumQuantity),
      );
    }
    return Boolean(
      (product.storage.type || (product.storage as any)?.storageType) &&
      (product.storage.capacity ||
        (product.storage as any)?.trigger ||
        (product.storage as any)?.minimumQuantity),
    );
  }, [product.storage]);

  const availableTabs = useMemo(() => {
    const list: Array<{ label: string; count: number }> = [];
    if (product.variants && product.variants.length > 0) {
      list.push({ label: "Variants", count: product.variants.length });
    }
    if (matchedPromos && matchedPromos.length > 0) {
      list.push({ label: "Promo", count: matchedPromos.length });
    }
    if (matchedGifts && matchedGifts.length > 0) {
      list.push({ label: "Gift", count: matchedGifts.length });
    }
    return list;
  }, [product.variants, matchedPromos, matchedGifts]);

  useEffect(() => {
    if (
      availableTabs.length > 0 &&
      !availableTabs.some((t) => t.label === activeTab)
    ) {
      setActiveTab(availableTabs[0].label);
    }
  }, [availableTabs, activeTab]);

  const getFormattedImgUrl = (url?: string) => {
    if (!url) return "";
    if (
      url.startsWith("http://") ||
      url.startsWith("https://") ||
      url.startsWith("blob:") ||
      url.startsWith("data:")
    ) {
      return url;
    }
    const baseUrl = process.env.REACT_APP_BASE_URL || "";
    const cleanPath = url.startsWith("/") ? url : `/${url}`;
    return `${baseUrl}${cleanPath}`;
  };

  const imgUrl = getFormattedImgUrl(product.image);

  return (
    <div className="space-y-4 text-[#212121]">
      {/* Product Summary Header Card */}
      <div className="  p-4 space-y-3 shadow-xs">
        <div className="flex justify-between items-start gap-4">
          <div className="flex gap-4 items-start">
            {imgUrl ? (
              <img
                src={imgUrl}
                alt={product.name}
                onError={(e) => {
                  (e.target as HTMLElement).style.display = "none";
                }}
                className="w-20 h-20 rounded-lg object-cover bg-white border border-[#D2D2D2] shrink-0 shadow-xs"
              />
            ) : (
              <div className="w-20 h-20 rounded-lg bg-slate-100 border border-[#D2D2D2] shrink-0 flex items-center justify-center text-slate-400">
                <IconGlobe size={28} />
              </div>
            )}
            <div className="space-y-1">
              <div className="flex flex-wrap gap-1.5 mb-1">
                {product.features?.hasVariants && (
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-yellow-100 text-yellow-700 border border-yellow-200/50">
                    Variants
                  </span>
                )}
                {product.features?.hasExpiry && (
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-700 border border-amber-200/50">
                    Expiry
                  </span>
                )}
                {product.features?.isDangerousGoods && (
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-rose-100 text-rose-700 border border-rose-200/50">
                    Dangerous
                  </span>
                )}
                {customsFields.hasAny && (
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-emerald-100 text-emerald-700 border border-emerald-200/50">
                    Customs
                  </span>
                )}
                {(matchedPromos.length > 0 ||
                  (product.features as any)?.hasPromo) && (
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-purple-100 text-purple-700 border border-purple-200/50">
                    Promo
                  </span>
                )}
                {(matchedGifts.length > 0 ||
                  (product.features as any)?.hasGift) && (
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-blue-100 text-blue-700 border border-blue-200/50">
                    Gift
                  </span>
                )}
              </div>
              <h2 className="text-base text-[#212121] font-bold">
                SKU: {product.sku}
              </h2>
              <h3 className="text-sm font-semibold text-[#212121]">
                {product.name}
              </h3>
              {product.category && (
                <p className="text-xs font-medium bg-white/80 text-[#212121]/70 px-2.5 py-0.5 rounded border border-slate-200 inline-block">
                  {product.category}
                </p>
              )}
            </div>
          </div>

          <div className="text-right shrink-0 space-y-1">
            <span className="text-base font-bold text-[#212121] block">
              SAR {product.price}
            </span>
            {product.discount > 0 && (
              <span className="text-xs font-medium text-red-600 bg-red-50 px-2 py-0.5 rounded border border-red-100 inline-block">
                (-SAR {product.discount})
              </span>
            )}
            <div className="pt-1">
              <span
                className={`px-2.5 py-0.5 rounded border text-[10px] font-semibold capitalize inline-block ${
                  (product.status || "ACTIVE").toUpperCase() === "ACTIVE"
                    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                    : "bg-rose-50 text-rose-700 border-rose-200"
                }`}
              >
                {product.status || "ACTIVE"}
              </span>
            </div>
          </div>
        </div>

        {(product.shortDesc || product.longDesc) && (
          <div className="border-t border-dashed border-slate-200 pt-2 space-y-1 text-xs text-[#212121]/80">
            {product.shortDesc && (
              <p>
                <b>Short Description:</b> {product.shortDesc}
              </p>
            )}
            {product.longDesc && (
              <p>
                <b>Long Description:</b> {product.longDesc}
              </p>
            )}
          </div>
        )}
        <div className="space-y-3">
          {/* Storage Profile & Dimensions Profile */}
          {/* {(hasStorage || hasDimensions) && (
            <div className="border border-dashed border-[#D2D2D2] rounded-lg overflow-hidden  w-full">
              <div
                className={`grid ${hasStorage && hasDimensions ? "grid-cols-2 divide-x divide-dashed divide-[#D2D2D2]" : "grid-cols-1"} w-full items-stretch`}
              > 
                {hasStorage && (
                  <div className="w-full flex flex-col h-full">
                    <div className="bg-gray-50 px-3 py-1.5 border-b border-dashed border-[#D2D2D2] w-full">
                      <span className="text-xs font-semibold text-[#212121] block">
                        Storage
                      </span>
                    </div>
                    {Array.isArray(product.storage) ? (
                      product.storage.map((s: any, idx: number) => (
                        <div
                          key={idx}
                          className="grid grid-cols-3 text-center divide-x divide-dashed divide-[#D2D2D2] border-b border-dashed border-[#D2D2D2] last:border-0 w-full flex-1 items-stretch"
                        >
                          <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
                            <p className="text-[10px] font-medium text-[#212121]/70">
                              Type:
                            </p>
                            <p className="text-[10px] font-medium text-[#212121]">
                              {s?.type || s?.storageType || "BINS"}
                            </p>
                          </div>
                          <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
                            <p className="text-[10px] font-medium text-[#212121]/70">
                              Cap:
                            </p>
                            <p className="text-[10px] font-medium text-[#212121]">
                              {s?.capacity ?? "—"}
                            </p>
                          </div>
                          <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
                            <p className="text-[10px] text-rose-500">Tri:</p>
                            <p className="text-[10px] font-medium text-rose-600">
                              {s?.trigger ?? s?.minimumQuantity ?? "—"}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="grid grid-cols-3 text-center divide-x divide-dashed divide-[#D2D2D2] border-b border-dashed border-[#D2D2D2] last:border-0 w-full flex-1 items-stretch">
                        <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
                          <p className="text-[10px] font-medium text-[#212121]/70">
                            Type:
                          </p>
                          <p className="text-[10px] font-medium text-[#212121]">
                            {product.storage?.type ||
                              (product.storage as any)?.storageType ||
                              "BINS"}
                          </p>
                        </div>
                        <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
                          <p className="text-[10px] font-medium text-[#212121]/70">
                            Cap:
                          </p>
                          <p className="text-[10px] font-medium text-[#212121]">
                            {product.storage?.capacity ?? "—"}
                          </p>
                        </div>
                        <div className="flex items-center gap-1.5 px-2.5 py-2.5 justify-center h-full">
                          <p className="text-[10px] text-rose-500">Tri:</p>
                          <p className="text-[10px] font-medium text-rose-600">
                            {product.storage?.trigger ??
                              (product.storage as any)?.minimumQuantity ??
                              "—"}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
 
                {hasDimensions && (
                  <div className="w-full flex flex-col h-full">
                    <div className="bg-gray-50 px-3 py-1.5 border-b border-dashed border-[#D2D2D2] w-full">
                      <span className="text-xs font-semibold text-[#212121] block">
                        Dimensions
                      </span>
                    </div>
                    <div className="grid grid-cols-4 text-center divide-x divide-dashed divide-[#D2D2D2] w-full flex-1 items-stretch">
                      <div className="flex flex-col items-center justify-center py-2.5 px-1 h-full">
                        <p className="text-[10px] font-medium text-[#212121]/70 whitespace-nowrap">
                          Weight:
                        </p>
                        <p className="text-[10px] font-medium text-[#212121] mt-0.5 whitespace-nowrap">
                          {product.dimensions?.weight &&
                          product.dimensions.weight !== "—"
                            ? `${product.dimensions.weight} g`
                            : "—"}
                        </p>
                      </div>
                      <div className="flex flex-col items-center justify-center py-2.5 px-1 h-full">
                        <p className="text-[10px] font-medium text-[#212121]/70 whitespace-nowrap">
                          Length:
                        </p>
                        <p className="text-[10px] font-medium text-[#212121] mt-0.5 whitespace-nowrap">
                          {product.dimensions?.length &&
                          product.dimensions.length !== "—"
                            ? `${product.dimensions.length} cm`
                            : "—"}
                        </p>
                      </div>
                      <div className="flex flex-col items-center justify-center py-2.5 px-1 h-full">
                        <p className="text-[10px] font-medium text-[#212121]/70 whitespace-nowrap">
                          Width:
                        </p>
                        <p className="text-[10px] font-medium text-[#212121] mt-0.5 whitespace-nowrap">
                          {product.dimensions?.width &&
                          product.dimensions.width !== "—"
                            ? `${product.dimensions.width} cm`
                            : "—"}
                        </p>
                      </div>
                      <div className="flex flex-col items-center justify-center py-2.5 px-1 h-full">
                        <p className="text-[10px] font-medium text-[#212121]/70 whitespace-nowrap">
                          Height:
                        </p>
                        <p className="text-[10px] font-medium text-[#212121] mt-0.5 whitespace-nowrap">
                          {product.dimensions?.height &&
                          product.dimensions.height !== "—"
                            ? `${product.dimensions.height} cm`
                            : "—"}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )} */}

          {(hasStorage || hasDimensions) && (
            <div className="border border-dashed border-[#D2D2D2] rounded-lg overflow-hidden w-full">
              <div
                className={`grid gap-1 ${
                  hasStorage && hasDimensions
                    ? "grid-cols-2 divide-x divide-dashed divide-[#D2D2D2]"
                    : "grid-cols-1"
                } w-full items-stretch`}
              >
                {/* ==================== STORAGE ==================== */}
                {hasStorage && (
                  <div className="w-full flex flex-col h-full min-w-0">
                    <div className="bg-gray-50 px-3 py-1.5 border-b border-dashed border-[#D2D2D2] w-full">
                      <span className="text-xs font-semibold text-[#212121] block">
                        Storage
                      </span>
                    </div>

                    <ListView
                      tdClassName="rounded-r-none rounded-l-none text-left bg-transparent py-2 text-[11px]"
                      mainDivClassName="bg-transparent"
                      trClassName="hover:bg-[#FBD037]/20"
                      mailDivClassName="p-0 bg-transparent"
                      thClassName="border-t text-left sticky top-0 z-20 text-[11px]"
                      data={
                        Array.isArray(product.storage)
                          ? product.storage
                          : product.storage
                            ? [product.storage]
                            : []
                      }
                      columns={[
                        {
                          label: "#",
                          render: (_: any, i: number) => (
                            <div className="font-medium text-[#212121]/70">
                              {i + 1}
                            </div>
                          ),
                        },
                        {
                          label: "Type",
                          render: (s: any) => (
                            <div className="font-medium text-[#212121]">
                              {s?.type || s?.storageType || "BINS"}
                            </div>
                          ),
                        },
                        {
                          label: "Cap",
                          render: (s: any) => (
                            <div className="font-medium text-[#212121]">
                              {s?.capacity ?? "—"}
                            </div>
                          ),
                        },
                        {
                          label: "Tri",
                          render: (s: any) => (
                            <div className="font-medium text-rose-600">
                              {s?.trigger ?? s?.minimumQuantity ?? "—"}
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                )}

                {/* ==================== DIMENSIONS ==================== */}
                {hasDimensions && (
                  <div className="w-full flex flex-col h-full min-w-0">
                    <div className="bg-gray-50 px-3 py-1.5 border-b border-dashed border-[#D2D2D2] w-full">
                      <span className="text-xs font-semibold text-[#212121] block">
                        Dimensions
                      </span>
                    </div>

                    <ListView
                      tdClassName="rounded-r-none rounded-l-none text-left bg-transparent py-2 text-[11px]"
                      mainDivClassName="bg-transparent"
                      trClassName="hover:bg-[#FBD037]/20"
                      mailDivClassName="p-0 bg-transparent"
                      thClassName="border-t text-left sticky top-0 z-20 text-[11px]"
                      data={product.dimensions ? [product.dimensions] : []}
                      columns={[
                        {
                          label: "#",
                          render: (_: any, i: number) => (
                            <div className="font-medium text-[#212121]/70">
                              {i + 1}
                            </div>
                          ),
                        },
                        {
                          label: "Weight",
                          render: (d: any) => (
                            <div className="font-medium text-[#212121]">
                              {d?.weight && d.weight !== "—"
                                ? `${d.weight} g`
                                : "—"}
                            </div>
                          ),
                        },
                        {
                          label: "Length",
                          render: (d: any) => (
                            <div className="font-medium text-[#212121]">
                              {d?.length && d.length !== "—"
                                ? `${d.length} cm`
                                : "—"}
                            </div>
                          ),
                        },
                        {
                          label: "Width",
                          render: (d: any) => (
                            <div className="font-medium text-[#212121]">
                              {d?.width && d.width !== "—"
                                ? `${d.width} cm`
                                : "—"}
                            </div>
                          ),
                        },
                        {
                          label: "Height",
                          render: (d: any) => (
                            <div className="font-medium text-[#212121]">
                              {d?.height && d.height !== "—"
                                ? `${d.height} cm`
                                : "—"}
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Customs Details */}
          {customsFields.hasAny && product.compliance && (
            <div className="border border-dashed border-[#D2D2D2] rounded-lg overflow-hidden  space-y-1.5">
              <div className="  px-3 py-1.5 border-b border-dashed border-[#D2D2D2] flex justify-between items-center">
                <span className="text-xs font-semibold text-[#212121] block">
                  Customs Details
                </span>
                {customsFields.hasHsCode && (
                  <span className="text-[10px] text-indigo-600 font-bold tracking-wider">
                    HS CODE {product.compliance.hsCode}
                  </span>
                )}
              </div>
              {(customsFields.hasRoute ||
                customsFields.hasDuty ||
                customsFields.hasVat ||
                customsFields.hasLicense) && (
                <div className="flex flex-wrap gap-x-4 gap-y-1 text-[#212121]/70 px-3 py-1">
                  {customsFields.hasRoute && (
                    <p className="text-[10px]">
                      Route:{" "}
                      <strong className="text-[#212121]">
                        {product.compliance.origin || "—"} →{" "}
                        {product.compliance.destination || "—"}
                      </strong>
                    </p>
                  )}
                  {customsFields.hasDuty && (
                    <p className="text-[10px]">
                      Tariffs:{" "}
                      <strong className="text-emerald-600">
                        {product.compliance.duty}% Duty
                      </strong>
                    </p>
                  )}
                  {customsFields.hasVat && (
                    <p className="text-[10px]">
                      VAT:{" "}
                      <strong className="text-indigo-600">
                        {product.compliance.vat}% Tax
                      </strong>
                    </p>
                  )}
                  {customsFields.hasLicense && (
                    <p className="text-[10px]">
                      Licence:{" "}
                      <strong className="text-[#212121]">
                        {product.compliance.license}
                      </strong>
                    </p>
                  )}
                </div>
              )}
              {customsFields.hasDocuments && (
                <div className="text-[10px] text-[#212121]/60 pt-1 border-t border-[#D2D2D2] px-3 py-1.5">
                  <strong>Mandatory Documentation:</strong>{" "}
                  {product.compliance.documents}
                </div>
              )}
            </div>
          )}

          {/* Dynamic Tabs: Variants / Promo / Gift */}
          {availableTabs.length > 0 && (
            <div className="border border-dashed border-[#D2D2D2] rounded-lg overflow-hidden">
              <div className="bg-gray-50 px-3 py-1.5 border-b border-dashed border-[#D2D2D2] flex justify-between items-center">
                {activeTab === "Variants" && (
                  <p className="text-xs font-semibold text-[#212121] block">
                    Variants Details ({product.variants?.length || 0})
                  </p>
                )}
                {activeTab === "Promo" && (
                  <p className="text-xs font-semibold text-[#212121] block">
                    Promo ({matchedPromos.length})
                  </p>
                )}
                {activeTab === "Gift" && (
                  <p className="text-xs font-semibold text-[#212121] block">
                    Gift ({matchedGifts.length})
                  </p>
                )}
                <div className="flex items-center gap-2">
                  {availableTabs.map((tab) => (
                    <button
                      key={tab.label}
                      onClick={() => setActiveTab(tab.label)}
                      className={`py-1 px-2.5 text-[10px] font-semibold rounded transition-all flex items-center justify-center border shrink-0 ${
                        activeTab === tab.label
                          ? "bg-[#FBD037]/20 text-[#000000] shadow-xs border-[#FBD037]"
                          : "bg-slate-100 text-slate-600 border-slate-200"
                      }`}
                    >
                      <span>
                        <T>{tab.label}</T>
                      </span>
                    </button>
                  ))}
                </div>
              </div>

              <div className="grid grid-cols-1 gap-1 max-h-48 overflow-y-auto p-2">
                {activeTab === "Variants" &&
                  product.variants &&
                  product.variants.length > 0 && (
                    <ListView
                      tdClassName="rounded-r-none rounded-l-none text-left bg-transparent py-1 text-[11px]"
                      mainDivClassName="bg-transparent"
                      trClassName="hover:bg-[#FBD037]/20"
                      mailDivClassName="p-0 bg-transparent"
                      thClassName="border-t text-left sticky top-0 z-20 text-[11px]"
                      data={product.variants}
                      columns={[
                        {
                          label: "#",
                          render: (_: any, i: number) => <div>{i + 1}</div>,
                        },
                        {
                          label: "SKU",
                          render: (c: any) => <div>{c.sku || "—"}</div>,
                        },
                        {
                          label: "Name",
                          render: (c: any) => <div>{c.name || "Variant"}</div>,
                        },
                        {
                          label: "Option Value",
                          render: (c: any) => <div>{c.value || "—"}</div>,
                        },
                        {
                          label: "Price (SAR)",
                          render: (c: any) => (
                            <div className="flex items-center gap-1 font-semibold">
                              <img
                                src="/img/riyal-icon.svg"
                                className="w-2.5 h-2.5"
                                alt=""
                              />
                              {c.price}
                            </div>
                          ),
                        },
                      ]}
                    />
                  )}

                {activeTab === "Promo" && (
                  <ListView
                    tdClassName="rounded-r-none rounded-l-none text-left bg-transparent py-1 text-[11px]"
                    mainDivClassName="bg-transparent"
                    trClassName="hover:bg-[#FBD037]/20"
                    mailDivClassName="p-0 bg-transparent"
                    thClassName="border-t text-left sticky top-0 z-20 text-[11px]"
                    data={matchedPromos}
                    onRowClick={(item: any) => onEditPromo?.(item)}
                    columns={[
                      {
                        label: "#",
                        render: (_: any, i: number) => <div>{i + 1}</div>,
                      },
                      {
                        label: "Promo Code",
                        render: (c: any) => (
                          <div className="font-semibold text-[#212121]">
                            {c.sku || c.promoCode || c.code || "PROMO-001"}
                          </div>
                        ),
                      },
                      {
                        label: "Product SKU",
                        render: (c: any) => {
                          const match = c.products?.find((item: any) => {
                            const itemSku = (
                              item.productSku ||
                              item.sku ||
                              item.productId ||
                              ""
                            ).toString();
                            return productSkus.some(
                              (s) =>
                                s.toString().toLowerCase() ===
                                itemSku.toLowerCase(),
                            );
                          });
                          const displaySku =
                            match?.productSku &&
                            match.productSku !== match.productId
                              ? match.productSku
                              : product.sku;
                          return (
                            <div className="font-medium text-[#212121]">
                              {displaySku}
                            </div>
                          );
                        },
                      },
                      {
                        label: "QTY",
                        render: (c: any) => {
                          const match = c.products?.find((item: any) => {
                            const itemSku = (
                              item.productSku ||
                              item.sku ||
                              item.productId ||
                              ""
                            ).toString();
                            return productSkus.some(
                              (s) =>
                                s.toString().toLowerCase() ===
                                itemSku.toLowerCase(),
                            );
                          });
                          const qtyVal = match?.qty ?? match?.quantity ?? 1;
                          return (
                            <div className="font-semibold text-slate-700">
                              {qtyVal}
                            </div>
                          );
                        },
                      },
                      {
                        label: "Date",
                        render: (c: any) => (
                          <div>
                            {c.startDate && c.endDate
                              ? `${c.startDate} - ${c.endDate}`
                              : c.startDate || c.endDate || "—"}
                          </div>
                        ),
                      },
                      {
                        label: "Status",
                        render: (c: any) => {
                          const isActive =
                            (c.status || "ACTIVE").toString().toLowerCase() ===
                            "active";
                          return (
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                onTogglePromoStatus?.(c.id, c.status);
                              }}
                              className={`w-9 h-5 flex items-center rounded-full p-0.5 transition-colors duration-200 cursor-pointer ${
                                isActive ? "bg-emerald-500" : "bg-slate-300"
                              }`}
                            >
                              <div
                                className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-200 ${
                                  isActive ? "translate-x-4" : "translate-x-0"
                                }`}
                              />
                            </button>
                          );
                        },
                      },
                    ]}
                  />
                )}

                {activeTab === "Gift" && (
                  <ListView
                    tdClassName="rounded-r-none rounded-l-none text-left bg-transparent py-1 text-[11px]"
                    mainDivClassName="bg-transparent"
                    trClassName="hover:bg-[#FBD037]/20"
                    mailDivClassName="p-0 bg-transparent"
                    thClassName="border-t text-left sticky top-0 z-20 text-[11px]"
                    data={matchedGifts}
                    onRowClick={(item: any) => onEditGift?.(item)}
                    columns={[
                      {
                        label: "#",
                        render: (_: any, i: number) => <div>{i + 1}</div>,
                      },
                      {
                        label: "Item / SKU",
                        render: (g: any) => (
                          <div className="space-y-1">
                            <div className="flex items-center gap-1.5">
                              <span className="font-bold text-[#212121]">
                                {g.mainProductSku}
                              </span>
                              <span className="px-1.5 py-0.2 bg-amber-100 text-amber-800 text-[9px] font-bold rounded">
                                MAIN
                              </span>
                            </div>
                            {g.giftItems && g.giftItems.length > 0 ? (
                              g.giftItems.map((gi: any, idx: number) => (
                                <div
                                  key={idx}
                                  className="flex items-center gap-1.5 pl-3 text-slate-600 text-[10px]"
                                >
                                  <span>
                                    ↳{" "}
                                    {gi.sku ||
                                      gi.giftSku ||
                                      gi.giftProductSku ||
                                      g.giftProductSku}
                                  </span>
                                  <span className="px-1.5 py-0.2 bg-emerald-100 text-emerald-800 text-[9px] font-bold rounded">
                                    GIFT
                                  </span>
                                </div>
                              ))
                            ) : (
                              <div className="flex items-center gap-1.5 pl-3 text-slate-600 text-[10px]">
                                <span>↳ {g.giftProductSku || g.giftSku}</span>
                                <span className="px-1.5 py-0.2 bg-emerald-100 text-emerald-800 text-[9px] font-bold rounded">
                                  GIFT
                                </span>
                              </div>
                            )}
                          </div>
                        ),
                      },
                      {
                        label: "QTY",
                        render: (g: any) => (
                          <div className="space-y-1">
                            <div>
                              <span className="px-1.5 py-0.5 bg-amber-50 text-amber-900 font-bold rounded">
                                {g.mainQty ?? g.triggerQty ?? 1}
                              </span>
                            </div>
                            {g.giftItems && g.giftItems.length > 0 ? (
                              g.giftItems.map((gi: any, idx: number) => (
                                <div key={idx} className="pl-3">
                                  <span className="px-1.5 py-0.2 bg-emerald-50 text-emerald-900 font-bold rounded">
                                    +{gi.qty ?? gi.giftQty ?? g.giftQty ?? 1}
                                  </span>
                                </div>
                              ))
                            ) : (
                              <div className="pl-3">
                                <span className="px-1.5 py-0.2 bg-emerald-50 text-emerald-900 font-bold rounded">
                                  +{g.giftQty ?? 1}
                                </span>
                              </div>
                            )}
                          </div>
                        ),
                      },
                      {
                        label: "Date",
                        render: (g: any) => (
                          <div>
                            {g.startDate
                              ? `${g.startDate} - ${g.endDate}`
                              : "—"}
                          </div>
                        ),
                      },
                      {
                        label: "Status",
                        render: (g: any) => (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              onToggleGiftStatus?.(g.id, g.status);
                            }}
                            className={`w-9 h-5 flex items-center rounded-full p-0.5 transition-colors duration-200 cursor-pointer ${
                              g.status === "active"
                                ? "bg-emerald-500"
                                : "bg-slate-300"
                            }`}
                          >
                            <div
                              className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-200 ${
                                g.status === "active"
                                  ? "translate-x-4"
                                  : "translate-x-0"
                              }`}
                            />
                          </button>
                        ),
                      },
                    ]}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
